exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
